'use strict';

export default class ProducerFac {
  static get UID() {
    return 'producerFac';
  }

  constructor($http, siteConst, BASE_URLS) {
    'ngInject';
    Object.assign(this, { $http, siteConst, BASE_URLS } );
  }

  getProducer(producerId) {
    console.log('-- gettinr producer');
    var url = `${this.BASE_URLS.API}/api/producer/${producerId}`;

    return this.$http.get(url);
  };

  static factory($http, siteConst, BASE_URLS) {
    return new ProducerFac($http, siteConst, BASE_URLS);
  }
}

ProducerFac.factory.$inject = ProducerFac.$inject;



// WEBPACK FOOTER //
// ./~/site_core/src/factories/producerFac.js